<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label style="text-transform: capitalize">{{ $t("plate.list") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="listFilter"
          :options="listOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:listFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label style="text-transform: capitalize">{{ $t("plate.brand") }} </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="brandFilter"
          :options="listOptionsBrand"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:brandFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label style="text-transform: capitalize">{{ $t("plate.model") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="modelFilter"
          :options="listOptionsModel"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:modelFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label style="text-transform: capitalize">{{ $t("plate.type") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="typeFilter"
          :options="listOptionsType"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    listOptions: {
      type: Array,
      default: null,
    },
    listFilter: {
      type: Array,
      default: null,
    },
    listOptionsBrand: {
      type: Array,
      default: null,
    },
    brandFilter: {
      type: Array,
      default: null,
    },
    listOptionsModel: {
      type: Array,
      default: null,
    },
    modelFilter: {
      type: Array,
      default: null,
    },
    listOptionsType: {
      type: Array,
      default: null,
    },
    typeFilter: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
